import React, { forwardRef, useMemo } from 'react';
import { s as styleInject, P as PropTypes } from '../style-inject.es-3bd340c8.js';
import '../index-65ee9985.js';
import '../_babelHelpers-a63acad8.js';
import { u as useAutoResize } from '../autoResize-73247714.js';
import { c as classnames } from '../index-bddb7af5.js';
import { u as util_2, a as util_1 } from '../index-989b4d2a.js';

var css = ".dv-border-box-4 {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.dv-border-box-4 .dv-reverse {\n  transform: rotate(180deg);\n}\n.dv-border-box-4 .dv-border-svg-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n}\n.dv-border-box-4 .dv-border-svg-container > polyline {\n  fill: none;\n}\n.dv-border-box-4 .sw1 {\n  stroke-width: 1;\n}\n.dv-border-box-4 .sw3 {\n  stroke-width: 3px;\n  stroke-linecap: round;\n}\n.dv-border-box-4 .dv-bb4-line-1 {\n  stroke-width: 1;\n}\n.dv-border-box-4 .dv-bb4-line-2 {\n  stroke-width: 1;\n}\n.dv-border-box-4 .dv-bb4-line-3 {\n  stroke-width: 3px;\n  stroke-linecap: round;\n}\n.dv-border-box-4 .dv-bb4-line-4 {\n  stroke-width: 3px;\n  stroke-linecap: round;\n}\n.dv-border-box-4 .dv-bb4-line-5 {\n  stroke-width: 1;\n}\n.dv-border-box-4 .dv-bb4-line-6 {\n  stroke-width: 1;\n}\n.dv-border-box-4 .dv-bb4-line-7 {\n  stroke-width: 1;\n}\n.dv-border-box-4 .dv-bb4-line-8 {\n  stroke-width: 3px;\n  stroke-linecap: round;\n}\n.dv-border-box-4 .dv-bb4-line-9 {\n  stroke-width: 3px;\n  stroke-linecap: round;\n  stroke-dasharray: 100 250;\n}\n.dv-border-box-4 .dv-bb4-line-10 {\n  stroke-width: 1;\n  stroke-dasharray: 80 270;\n}\n.dv-border-box-4 .border-box-content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n";
styleInject(css);

var defaultColor = ['red', 'rgba(0,0,255,0.8)'];

var BorderBox = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === undefined ? false : _ref$reverse,
      className = _ref.className,
      style = _ref.style,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? [] : _ref$color,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;

  var _useAutoResize = useAutoResize(ref),
      width = _useAutoResize.width,
      height = _useAutoResize.height,
      domRef = _useAutoResize.domRef;

  var mergedColor = useMemo(function () {
    return util_2(util_1(defaultColor, true), color || []);
  }, [color]);

  var classNames = useMemo(function () {
    return classnames('dv-border-box-4', className);
  }, [className]);

  return React.createElement(
    'div',
    { className: classNames, style: style, ref: domRef },
    React.createElement(
      'svg',
      {
        className: 'dv-border-svg-container ' + (reverse && 'dv-reverse'),
        width: width,
        height: height
      },
      React.createElement('polygon', { fill: backgroundColor, points: '\n          ' + (width - 15) + ', 22 170, 22 150, 7 40, 7 28, 21 32, 24\n          16, 42 16, ' + (height - 32) + ' 41, ' + (height - 7) + ' ' + (width - 15) + ', ' + (height - 7) + '\n        ' }),
      React.createElement('polyline', {
        className: 'dv-bb4-line-1',
        stroke: mergedColor[0],
        points: '145, ' + (height - 5) + ' 40, ' + (height - 5) + ' 10, ' + (height - 35) + '\n          10, 40 40, 5 150, 5 170, 20 ' + (width - 15) + ', 20'
      }),
      React.createElement('polyline', {
        className: 'dv-bb4-line-2',
        stroke: mergedColor[1],
        points: '245, ' + (height - 1) + ' 36, ' + (height - 1) + ' 14, ' + (height - 23) + '\n          14, ' + (height - 100)
      }),
      React.createElement('polyline', {
        className: 'dv-bb4-line-3',
        stroke: mergedColor[0],
        points: '7, ' + (height - 40) + ' 7, ' + (height - 75)
      }),
      React.createElement('polyline', { className: 'dv-bb4-line-4', stroke: mergedColor[0], points: '28, 24 13, 41 13, 64' }),
      React.createElement('polyline', { className: 'dv-bb4-line-5', stroke: mergedColor[0], points: '5, 45 5, 140' }),
      React.createElement('polyline', { className: 'dv-bb4-line-6', stroke: mergedColor[1], points: '14, 75 14, 180' }),
      React.createElement('polyline', {
        className: 'dv-bb4-line-7',
        stroke: mergedColor[1],
        points: '55, 11 147, 11 167, 26 250, 26'
      }),
      React.createElement('polyline', { className: 'dv-bb4-line-8', stroke: mergedColor[1], points: '158, 5 173, 16' }),
      React.createElement('polyline', {
        className: 'dv-bb4-line-9',
        stroke: mergedColor[0],
        points: '200, 17 ' + (width - 10) + ', 17'
      }),
      React.createElement('polyline', {
        className: 'dv-bb4-line-10',
        stroke: mergedColor[1],
        points: '385, 17 ' + (width - 10) + ', 17'
      })
    ),
    React.createElement(
      'div',
      { className: 'border-box-content' },
      children
    )
  );
});

BorderBox.propTypes = {
  children: PropTypes.node,
  reverse: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.array,
  backgroundColor: PropTypes.string

  // 指定 props 的默认值：
};BorderBox.defaultProps = {
  reverse: false,
  backgroundColor: 'transparent'
};

export default BorderBox;
//# sourceMappingURL=index.js.map
